<canvas  #canvas style="background-color:white" style="width: 100%;height: 100%;"></canvas>